import { useState } from "react";
import { addressList } from "../content";

const filters = ["全部", "可用", "备用", "维护中", "待验证"] as const;

const statusColor: Record<string, { dot: string; text: string; bg: string }> = {
  可用: { dot: "bg-accent-500", text: "text-accent-700", bg: "bg-accent-100" },
  备用: { dot: "bg-secondary-500", text: "text-secondary-800", bg: "bg-secondary-100" },
  维护中: { dot: "bg-foreground-400", text: "text-foreground-600", bg: "bg-foreground-100" },
  待验证: { dot: "bg-primary-400", text: "text-primary-700", bg: "bg-primary-100" },
};

export default function AddressHub() {
  const [active, setActive] = useState<(typeof filters)[number]>("全部");

  const list = active === "全部" ? addressList : addressList.filter((a) => a.status === active);

  return (
    <section id="address" className="mx-auto max-w-6xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="max-w-2xl">
        <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
          <i className="ri-pushpin-2-line" /> 多个地址汇总
        </p>
        <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
          吃瓜网址，备用几个随手存好
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
          同一份内容，多开几个入口总没错。下面的地址带上了实时状态与速度，能开哪个一眼看清，按需收藏即可。
        </p>
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-2">
        {filters.map((f) => (
          <button
            key={f}
            type="button"
            onClick={() => setActive(f)}
            className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
              active === f
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {f}
          </button>
        ))}
        <span className="ml-auto hidden text-xs text-foreground-500 sm:inline">共 {list.length} 个入口</span>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((a) => {
          const c = statusColor[a.status];
          return (
            <article
              key={a.id}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-transform hover:-translate-y-1"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700">
                  <i className="ri-price-tag-3-line" /> {a.tag}
                </span>
                <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${c.bg} ${c.text}`}>
                  <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
                  {a.status}
                </span>
              </div>
              <h3 className="mt-4 text-lg font-bold text-foreground-950">{a.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-dashboard-3-line" /> {a.speed}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" /> {a.upd}
                </span>
              </div>
            </article>
          );
        })}
      </div>

      <div className="mt-8 flex flex-col items-start gap-3 rounded-2xl bg-accent-100 p-5 sm:flex-row sm:items-center">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xl text-background-50">
          <i className="ri-lightbulb-flash-line" />
        </span>
        <div className="flex-1">
          <h3 className="font-bold text-foreground-950">小贴士：别把鸡蛋放一个篮子里</h3>
          <p className="mt-1 text-sm leading-relaxed text-foreground-700">
            建议至少收藏 2–3 个入口。主站负责日常，备用地址只用来应急，谁新谁稳就优先用谁，长期下来最省心。
          </p>
        </div>
      </div>
    </section>
  );
}